'use client';

import * as React from 'react';
import { createPortal } from 'react-dom';
import { ReactionsButton } from './ReactionsButton';

export function InjectReactionsIntoBar() {
  const [container, setContainer] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    if (typeof window === 'undefined') return;

    const tryInsert = () => {
      const controlBar = document.querySelector(
        'body > main > div > div.lk-video-conference > div.lk-video-conference-inner > div.lk-control-bar',
      ) as HTMLElement | null;

      if (!controlBar) return false;

      // Verifica se já foi injetado
      const existingReactions = controlBar.querySelector('[data-reactions-injected]');
      if (existingReactions) {
        setContainer(existingReactions as HTMLElement);
        return true;
      }

      // Tenta encontrar o botão de hand raise para inserir ao lado
      const handRaiseBtn = controlBar.querySelector('[data-hand-raise-injected]');
      const screenShareBtn = controlBar.querySelector('[data-lk-source="screen_share"]');
      
      let referenceElement = handRaiseBtn?.nextSibling || screenShareBtn?.nextSibling || screenShareBtn;

      if (referenceElement) {
        const host = document.createElement('div');
        host.setAttribute('data-reactions-injected', 'true');
        host.style.display = 'inline-flex';
        host.style.alignItems = 'center';
        host.style.justifyContent = 'center';
        host.style.position = 'relative';
        host.style.overflow = 'visible';
        host.style.marginLeft = '0';

        referenceElement.parentNode?.insertBefore(host, referenceElement.nextSibling);
        setContainer(host);
        return true;
      }

      return false;
    };

    if (tryInsert()) return;

    const observer = new MutationObserver((mutations) => {
      let shouldTryInsert = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node as Element;
              if (
                element.classList?.contains('lk-control-bar') ||
                element.querySelector?.('.lk-control-bar')
              ) {
                shouldTryInsert = true;
              }
            }
          });
        }
      });

      if (shouldTryInsert) {
        setTimeout(() => tryInsert(), 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const interval = setInterval(() => {
      if (tryInsert()) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      observer.disconnect();
      clearInterval(interval);

      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };
  }, []);

  if (!container) return null;

  return createPortal(<ReactionsButton inline />, container);
}
